import { createReducer, on } from '@ngrx/store';
import { consumptionInitialState, ConsumptionState } from '@store/states/consumption.state';
import { consumptionActions } from '@store/actions/consumption.actions';
import { isEqual } from 'lodash-es';

export const consumptionReducer = createReducer(
  consumptionInitialState,
  on(
    consumptionActions.setMapGeometry,
    (state, { geometry }): ConsumptionState => ({
      ...state,
      map: {
        ...state.map,
        geometry,
        errorGeometry: null,
      },
    })
  ),
  on(
    consumptionActions.setMapFilters,
    (state, { filter }): ConsumptionState => ({
      ...state,
      map: {
        ...state.map,
        filter,
      },
    })
  ),
  on(
    consumptionActions.setMapCoords,
    (state, { coords }): ConsumptionState => ({
      ...state,
      map: {
        ...state.map,
        coords,
        errorCoords: null,
      },
    })
  ),
  on(
    consumptionActions.setMapGeometryError,
    (state, { error }): ConsumptionState => ({
      ...state,
      map: {
        ...state.map,
        errorGeometry: error,
        geometry: null,
      },
    })
  ),
  on(
    consumptionActions.setMapCoordsError,
    (state, { error }): ConsumptionState => ({
      ...state,
      map: {
        ...state.map,
        errorCoords: error,
        coords: null,
      },
    })
  ),
  on(
    consumptionActions.filterRequestList,
    (state, { filter }): ConsumptionState => ({
      ...state,
      requestList: {
        ...state.requestList,
        filter,
        page: {
          ...state.requestList.page,
          pageIndex: 1,
        },
      },
    })
  ),
  on(
    consumptionActions.pageRequestList,
    (state, { page }): ConsumptionState => ({
      ...state,
      requestList: {
        ...state.requestList,
        page,
      },
    })
  ),
  on(
    consumptionActions.sortRequestList,
    (state, { sort }): ConsumptionState => ({
      ...state,
      requestList: {
        ...state.requestList,
        sort,
      },
    })
  ),
  on(
    consumptionActions.setRequestListError,
    (state, { error }): ConsumptionState => ({
      ...state,
      requestList: {
        ...state.requestList,
        error,
        data: [],
      },
    })
  ),
  on(
    consumptionActions.setRequestList,
    (state, { data }): ConsumptionState => ({
      ...state,
      requestList: {
        ...state.requestList,
        error: null,
        data,
      },
    })
  ),
  on(consumptionActions.changeTab, (state, { index }): ConsumptionState => {
    if (index >= 0 && index < state.tabs.length) {
      return {
        ...state,
        currentTab: state.tabs[index],
      };
    }
    return state;
  }),
  on(
    consumptionActions.initFilter,
    (state, { filter }): ConsumptionState => ({
      ...state,
      graphs: {
        ...state.graphs,
        accumulated: {
          ...state.graphs.accumulated,
          filter,
        },
        comparative: {
          ...state.graphs.comparative,
          filter: {
            ...filter,
            installations: filter.installations.slice(0, 15),
          },
        },
      },
    })
  ),
  on(
    consumptionActions.setAccumulatedGraphType,
    (state, { graphType }): ConsumptionState => ({
      ...state,
      graphs: {
        ...state.graphs,
        accumulated: {
          ...state.graphs.accumulated,
          graphType,
        },
      },
    })
  ),
  on(consumptionActions.setAccumulatedFilter, (state, { filter }): ConsumptionState => {
    const currentFilter = state.graphs.accumulated.filter;
    if (isEqual(currentFilter, filter)) {
      return state;
    }
    return {
      ...state,
      graphs: {
        ...state.graphs,
        accumulated: {
          ...state.graphs.accumulated,
          filter,
        },
      },
    };
  }),
  on(consumptionActions.setAccumulatedData, (state, { previousData, currentData }): ConsumptionState => {
    if (!!previousData || !!currentData) {
      return {
        ...state,
        graphs: {
          ...state.graphs,
          accumulated: {
            ...state.graphs.accumulated,
            previousData,
            currentData,
            error: false,
          },
        },
      };
    }
    return {
      ...state,
      graphs: {
        ...state.graphs,
        accumulated: {
          ...state.graphs.accumulated,
          previousData: null,
          currentData: null,
          error: true,
        },
      },
    };
  }),
  on(
    consumptionActions.setComparativeGraphType,
    (state, { graphType }): ConsumptionState => ({
      ...state,
      graphs: {
        ...state.graphs,
        comparative: {
          ...state.graphs.comparative,
          graphType,
        },
      },
    })
  ),
  on(consumptionActions.setComparativeFilter, (state, { filter }): ConsumptionState => {
    const currentFilter = state.graphs.comparative.filter;
    if (isEqual(currentFilter, filter)) {
      return state;
    }
    return {
      ...state,
      graphs: {
        ...state.graphs,
        comparative: {
          ...state.graphs.comparative,
          filter,
        },
      },
    };
  }),
  on(
    consumptionActions.setComparativeData,
    (state, { data }): ConsumptionState => ({
      ...state,
      graphs: {
        ...state.graphs,
        comparative: {
          ...state.graphs.comparative,
          error: null,
          data,
        },
      },
    })
  ),
  on(
    consumptionActions.setComparativeError,
    (state, { error }): ConsumptionState => ({
      ...state,
      graphs: {
        ...state.graphs,
        comparative: {
          ...state.graphs.comparative,
          data: null,
          error,
        },
      },
    })
  )
);
